"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrpcWebImpl = exports.QueryShowCreateTableDesc = exports.QuerySQLListDatabasesDesc = exports.QuerySQLListTablesDesc = exports.QuerySimpleSQLQueryDesc = exports.QuerySQLQueryDesc = exports.QueryParamsDesc = exports.QuerySearchDocDesc = exports.QueryGetDocDesc = exports.QueryGetSchemaDesc = exports.QueryListSchemaDesc = exports.QueryDesc = exports.QueryClientImpl = exports.ShowCreateTableResponse = exports.ShowCreateTableRequest = exports.SQLListDatabasesResponse = exports.SQLListDatabasesRequest = exports.SQLListTablesResponse = exports.SQLListTablesRequest = exports.SimpleSQLQueryResponse_RowValue = exports.SimpleSQLQueryResponse_ResultSet_RowEntry = exports.SimpleSQLQueryResponse_ResultSet = exports.SimpleSQLQueryResponse = exports.SQLQueryResponse = exports.SQLQueryRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.FieldValueFactor = exports.SearchFilter = exports.SearchFilters = exports.strings = exports.DocItem_HighlightEntry = exports.DocItem = exports.Meta = exports.SearchDocResponse_FacetEntry = exports.SearchDocResponse = exports.SearchDocRequest = exports.GetDocResponse = exports.GetDocRequest = exports.GetSchemaResponse = exports.GetSchemaRequest = exports.ListSchemaResponse = exports.ListSchemaRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const grpc_web_1 = require("@improbable-eng/grpc-web");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const pagination_1 = require("../cosmos/base/query/v1beta1/pagination");
const index_1 = require("../index/index");
const params_1 = require("../index/params");
const sql_engine_1 = require("../index/sql_engine");
const browser_headers_1 = require("browser-headers");
exports.protobufPackage = "blockved.glitterchain.index";
const baseListSchemaRequest = {};
exports.ListSchemaRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseListSchemaRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseListSchemaRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseListSchemaRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseListSchemaResponse = {};
exports.ListSchemaResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.schemas) {
            index_1.Schema.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseListSchemaResponse);
        message.schemas = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.schemas.push(index_1.Schema.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseListSchemaResponse);
        message.schemas = [];
        if (object.schemas !== undefined && object.schemas !== null) {
            for (const e of object.schemas) {
                message.schemas.push(index_1.Schema.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.schemas) {
            obj.schemas = message.schemas.map((e) => (e ? index_1.Schema.toJSON(e) : undefined));
        }
        else {
            obj.schemas = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseListSchemaResponse);
        message.schemas = [];
        if (object.schemas !== undefined && object.schemas !== null) {
            for (const e of object.schemas) {
                message.schemas.push(index_1.Schema.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseGetSchemaRequest = { schemaName: "" };
exports.GetSchemaRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.schemaName !== "") {
            writer.uint32(10).string(message.schemaName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetSchemaRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.schemaName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseGetSchemaRequest);
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = String(object.schemaName);
        }
        else {
            message.schemaName = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.schemaName !== undefined && (obj.schemaName = message.schemaName);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetSchemaRequest);
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = object.schemaName;
        }
        else {
            message.schemaName = "";
        }
        return message;
    },
};
const baseGetSchemaResponse = {};
exports.GetSchemaResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.schema !== undefined) {
            index_1.Schema.encode(message.schema, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetSchemaResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.schema = index_1.Schema.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseGetSchemaResponse);
        if (object.schema !== undefined && object.schema !== null) {
            message.schema = index_1.Schema.fromJSON(object.schema);
        }
        else {
            message.schema = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.schema !== undefined && (obj.schema = message.schema ? index_1.Schema.toJSON(message.schema) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetSchemaResponse);
        if (object.schema !== undefined && object.schema !== null) {
            message.schema = index_1.Schema.fromPartial(object.schema);
        }
        else {
            message.schema = undefined;
        }
        return message;
    },
};
const baseGetDocRequest = { schemaName: "", docID: "" };
exports.GetDocRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.schemaName !== "") {
            writer.uint32(10).string(message.schemaName);
        }
        if (message.docID !== "") {
            writer.uint32(18).string(message.docID);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetDocRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.schemaName = reader.string();
                    break;
                case 2:
                    message.docID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseGetDocRequest);
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = String(object.schemaName);
        }
        else {
            message.schemaName = "";
        }
        if (object.docID !== undefined && object.docID !== null) {
            message.docID = String(object.docID);
        }
        else {
            message.docID = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.schemaName !== undefined && (obj.schemaName = message.schemaName);
        message.docID !== undefined && (obj.docID = message.docID);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetDocRequest);
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = object.schemaName;
        }
        else {
            message.schemaName = "";
        }
        if (object.docID !== undefined && object.docID !== null) {
            message.docID = object.docID;
        }
        else {
            message.docID = "";
        }
        return message;
    },
};
const baseGetDocResponse = {};
exports.GetDocResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.doc !== undefined) {
            index_1.Doc.encode(message.doc, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetDocResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.doc = index_1.Doc.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseGetDocResponse);
        if (object.doc !== undefined && object.doc !== null) {
            message.doc = index_1.Doc.fromJSON(object.doc);
        }
        else {
            message.doc = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.doc !== undefined && (obj.doc = message.doc ? index_1.Doc.toJSON(message.doc) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetDocResponse);
        if (object.doc !== undefined && object.doc !== null) {
            message.doc = index_1.Doc.fromPartial(object.doc);
        }
        else {
            message.doc = undefined;
        }
        return message;
    },
};
const baseSearchDocRequest = {
    schemaName: "",
    query: "",
    queryField: "",
    aggsField: "",
    orderBy: "",
    limit: long_1.default.ZERO,
    page: long_1.default.ZERO,
};
exports.SearchDocRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.schemaName !== "") {
            writer.uint32(10).string(message.schemaName);
        }
        if (message.query !== "") {
            writer.uint32(18).string(message.query);
        }
        for (const v of message.queryField) {
            writer.uint32(26).string(v);
        }
        for (const v of message.aggsField) {
            writer.uint32(34).string(v);
        }
        if (message.filter !== undefined) {
            exports.SearchFilters.encode(message.filter, writer.uint32(42).fork()).ldelim();
        }
        if (message.orderBy !== "") {
            writer.uint32(50).string(message.orderBy);
        }
        if (!message.limit.isZero()) {
            writer.uint32(56).int64(message.limit);
        }
        if (!message.page.isZero()) {
            writer.uint32(64).int64(message.page);
        }
        if (message.factor !== undefined) {
            exports.FieldValueFactor.encode(message.factor, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSearchDocRequest);
        message.queryField = [];
        message.aggsField = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.schemaName = reader.string();
                    break;
                case 2:
                    message.query = reader.string();
                    break;
                case 3:
                    message.queryField.push(reader.string());
                    break;
                case 4:
                    message.aggsField.push(reader.string());
                    break;
                case 5:
                    message.filter = exports.SearchFilters.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.orderBy = reader.string();
                    break;
                case 7:
                    message.limit = reader.int64();
                    break;
                case 8:
                    message.page = reader.int64();
                    break;
                case 9:
                    message.factor = exports.FieldValueFactor.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSearchDocRequest);
        message.queryField = [];
        message.aggsField = [];
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = String(object.schemaName);
        }
        else {
            message.schemaName = "";
        }
        if (object.query !== undefined && object.query !== null) {
            message.query = String(object.query);
        }
        else {
            message.query = "";
        }
        if (object.queryField !== undefined && object.queryField !== null) {
            for (const e of object.queryField) {
                message.queryField.push(String(e));
            }
        }
        if (object.aggsField !== undefined && object.aggsField !== null) {
            for (const e of object.aggsField) {
                message.aggsField.push(String(e));
            }
        }
        if (object.filter !== undefined && object.filter !== null) {
            message.filter = exports.SearchFilters.fromJSON(object.filter);
        }
        else {
            message.filter = undefined;
        }
        if (object.orderBy !== undefined && object.orderBy !== null) {
            message.orderBy = String(object.orderBy);
        }
        else {
            message.orderBy = "";
        }
        if (object.limit !== undefined && object.limit !== null) {
            message.limit = long_1.default.fromString(object.limit);
        }
        else {
            message.limit = long_1.default.ZERO;
        }
        if (object.page !== undefined && object.page !== null) {
            message.page = long_1.default.fromString(object.page);
        }
        else {
            message.page = long_1.default.ZERO;
        }
        if (object.factor !== undefined && object.factor !== null) {
            message.factor = exports.FieldValueFactor.fromJSON(object.factor);
        }
        else {
            message.factor = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.schemaName !== undefined && (obj.schemaName = message.schemaName);
        message.query !== undefined && (obj.query = message.query);
        if (message.queryField) {
            obj.queryField = message.queryField.map((e) => e);
        }
        else {
            obj.queryField = [];
        }
        if (message.aggsField) {
            obj.aggsField = message.aggsField.map((e) => e);
        }
        else {
            obj.aggsField = [];
        }
        message.filter !== undefined &&
            (obj.filter = message.filter ? exports.SearchFilters.toJSON(message.filter) : undefined);
        message.orderBy !== undefined && (obj.orderBy = message.orderBy);
        message.limit !== undefined && (obj.limit = (message.limit || long_1.default.ZERO).toString());
        message.page !== undefined && (obj.page = (message.page || long_1.default.ZERO).toString());
        message.factor !== undefined &&
            (obj.factor = message.factor ? exports.FieldValueFactor.toJSON(message.factor) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSearchDocRequest);
        message.queryField = [];
        message.aggsField = [];
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = object.schemaName;
        }
        else {
            message.schemaName = "";
        }
        if (object.query !== undefined && object.query !== null) {
            message.query = object.query;
        }
        else {
            message.query = "";
        }
        if (object.queryField !== undefined && object.queryField !== null) {
            for (const e of object.queryField) {
                message.queryField.push(e);
            }
        }
        if (object.aggsField !== undefined && object.aggsField !== null) {
            for (const e of object.aggsField) {
                message.aggsField.push(e);
            }
        }
        if (object.filter !== undefined && object.filter !== null) {
            message.filter = exports.SearchFilters.fromPartial(object.filter);
        }
        else {
            message.filter = undefined;
        }
        if (object.orderBy !== undefined && object.orderBy !== null) {
            message.orderBy = object.orderBy;
        }
        else {
            message.orderBy = "";
        }
        if (object.limit !== undefined && object.limit !== null) {
            message.limit = object.limit;
        }
        else {
            message.limit = long_1.default.ZERO;
        }
        if (object.page !== undefined && object.page !== null) {
            message.page = object.page;
        }
        else {
            message.page = long_1.default.ZERO;
        }
        if (object.factor !== undefined && object.factor !== null) {
            message.factor = exports.FieldValueFactor.fromPartial(object.factor);
        }
        else {
            message.factor = undefined;
        }
        return message;
    },
};
const baseSearchDocResponse = { searchTime: long_1.default.ZERO, schemaName: "" };
exports.SearchDocResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.searchTime.isZero()) {
            writer.uint32(8).int64(message.searchTime);
        }
        if (message.schemaName !== "") {
            writer.uint32(18).string(message.schemaName);
        }
        if (message.meta !== undefined) {
            exports.Meta.encode(message.meta, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.items) {
            exports.DocItem.encode(v, writer.uint32(34).fork()).ldelim();
        }
        Object.entries(message.facet).forEach(([key, value]) => {
            exports.SearchDocResponse_FacetEntry.encode({ key: key, value }, writer.uint32(42).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSearchDocResponse);
        message.items = [];
        message.facet = {};
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.searchTime = reader.int64();
                    break;
                case 2:
                    message.schemaName = reader.string();
                    break;
                case 3:
                    message.meta = exports.Meta.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.items.push(exports.DocItem.decode(reader, reader.uint32()));
                    break;
                case 5:
                    const entry5 = exports.SearchDocResponse_FacetEntry.decode(reader, reader.uint32());
                    if (entry5.value !== undefined) {
                        message.facet[entry5.key] = entry5.value;
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSearchDocResponse);
        message.items = [];
        message.facet = {};
        if (object.searchTime !== undefined && object.searchTime !== null) {
            message.searchTime = long_1.default.fromString(object.searchTime);
        }
        else {
            message.searchTime = long_1.default.ZERO;
        }
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = String(object.schemaName);
        }
        else {
            message.schemaName = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = exports.Meta.fromJSON(object.meta);
        }
        else {
            message.meta = undefined;
        }
        if (object.items !== undefined && object.items !== null) {
            for (const e of object.items) {
                message.items.push(exports.DocItem.fromJSON(e));
            }
        }
        if (object.facet !== undefined && object.facet !== null) {
            Object.entries(object.facet).forEach(([key, value]) => {
                message.facet[key] = exports.SearchFilters.fromJSON(value);
            });
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.searchTime !== undefined && (obj.searchTime = (message.searchTime || long_1.default.ZERO).toString());
        message.schemaName !== undefined && (obj.schemaName = message.schemaName);
        message.meta !== undefined && (obj.meta = message.meta ? exports.Meta.toJSON(message.meta) : undefined);
        if (message.items) {
            obj.items = message.items.map((e) => (e ? exports.DocItem.toJSON(e) : undefined));
        }
        else {
            obj.items = [];
        }
        obj.facet = {};
        if (message.facet) {
            Object.entries(message.facet).forEach(([k, v]) => {
                obj.facet[k] = exports.SearchFilters.toJSON(v);
            });
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSearchDocResponse);
        message.items = [];
        message.facet = {};
        if (object.searchTime !== undefined && object.searchTime !== null) {
            message.searchTime = object.searchTime;
        }
        else {
            message.searchTime = long_1.default.ZERO;
        }
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = object.schemaName;
        }
        else {
            message.schemaName = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = exports.Meta.fromPartial(object.meta);
        }
        else {
            message.meta = undefined;
        }
        if (object.items !== undefined && object.items !== null) {
            for (const e of object.items) {
                message.items.push(exports.DocItem.fromPartial(e));
            }
        }
        if (object.facet !== undefined && object.facet !== null) {
            Object.entries(object.facet).forEach(([key, value]) => {
                if (value !== undefined) {
                    message.facet[key] = exports.SearchFilters.fromPartial(value);
                }
            });
        }
        return message;
    },
};
const baseSearchDocResponse_FacetEntry = { key: "" };
exports.SearchDocResponse_FacetEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.SearchFilters.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSearchDocResponse_FacetEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = exports.SearchFilters.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSearchDocResponse_FacetEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = String(object.key);
        }
        else {
            message.key = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = exports.SearchFilters.fromJSON(object.value);
        }
        else {
            message.value = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined &&
            (obj.value = message.value ? exports.SearchFilters.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSearchDocResponse_FacetEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = object.key;
        }
        else {
            message.key = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = exports.SearchFilters.fromPartial(object.value);
        }
        else {
            message.value = undefined;
        }
        return message;
    },
};
const baseMeta = {
    currentPage: long_1.default.ZERO,
    totalPages: long_1.default.ZERO,
    totalResults: long_1.default.ZERO,
    size: long_1.default.ZERO,
    sortedBy: "",
};
exports.Meta = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.currentPage.isZero()) {
            writer.uint32(8).int64(message.currentPage);
        }
        if (!message.totalPages.isZero()) {
            writer.uint32(16).int64(message.totalPages);
        }
        if (!message.totalResults.isZero()) {
            writer.uint32(24).int64(message.totalResults);
        }
        if (!message.size.isZero()) {
            writer.uint32(32).int64(message.size);
        }
        if (message.sortedBy !== "") {
            writer.uint32(42).string(message.sortedBy);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMeta);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.currentPage = reader.int64();
                    break;
                case 2:
                    message.totalPages = reader.int64();
                    break;
                case 3:
                    message.totalResults = reader.int64();
                    break;
                case 4:
                    message.size = reader.int64();
                    break;
                case 5:
                    message.sortedBy = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMeta);
        if (object.currentPage !== undefined && object.currentPage !== null) {
            message.currentPage = long_1.default.fromString(object.currentPage);
        }
        else {
            message.currentPage = long_1.default.ZERO;
        }
        if (object.totalPages !== undefined && object.totalPages !== null) {
            message.totalPages = long_1.default.fromString(object.totalPages);
        }
        else {
            message.totalPages = long_1.default.ZERO;
        }
        if (object.totalResults !== undefined && object.totalResults !== null) {
            message.totalResults = long_1.default.fromString(object.totalResults);
        }
        else {
            message.totalResults = long_1.default.ZERO;
        }
        if (object.size !== undefined && object.size !== null) {
            message.size = long_1.default.fromString(object.size);
        }
        else {
            message.size = long_1.default.ZERO;
        }
        if (object.sortedBy !== undefined && object.sortedBy !== null) {
            message.sortedBy = String(object.sortedBy);
        }
        else {
            message.sortedBy = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.currentPage !== undefined && (obj.currentPage = (message.currentPage || long_1.default.ZERO).toString());
        message.totalPages !== undefined && (obj.totalPages = (message.totalPages || long_1.default.ZERO).toString());
        message.totalResults !== undefined && (obj.totalResults = (message.totalResults || long_1.default.ZERO).toString());
        message.size !== undefined && (obj.size = (message.size || long_1.default.ZERO).toString());
        message.sortedBy !== undefined && (obj.sortedBy = message.sortedBy);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMeta);
        if (object.currentPage !== undefined && object.currentPage !== null) {
            message.currentPage = object.currentPage;
        }
        else {
            message.currentPage = long_1.default.ZERO;
        }
        if (object.totalPages !== undefined && object.totalPages !== null) {
            message.totalPages = object.totalPages;
        }
        else {
            message.totalPages = long_1.default.ZERO;
        }
        if (object.totalResults !== undefined && object.totalResults !== null) {
            message.totalResults = object.totalResults;
        }
        else {
            message.totalResults = long_1.default.ZERO;
        }
        if (object.size !== undefined && object.size !== null) {
            message.size = object.size;
        }
        else {
            message.size = long_1.default.ZERO;
        }
        if (object.sortedBy !== undefined && object.sortedBy !== null) {
            message.sortedBy = object.sortedBy;
        }
        else {
            message.sortedBy = "";
        }
        return message;
    },
};
const baseDocItem = { data: "", score: 0 };
exports.DocItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.Highlight).forEach(([key, value]) => {
            exports.DocItem_HighlightEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        if (message.data !== "") {
            writer.uint32(18).string(message.data);
        }
        if (message.score !== 0) {
            writer.uint32(25).double(message.score);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDocItem);
        message.Highlight = {};
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    const entry1 = exports.DocItem_HighlightEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.Highlight[entry1.key] = entry1.value;
                    }
                    break;
                case 2:
                    message.data = reader.string();
                    break;
                case 3:
                    message.score = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDocItem);
        message.Highlight = {};
        if (object.Highlight !== undefined && object.Highlight !== null) {
            Object.entries(object.Highlight).forEach(([key, value]) => {
                message.Highlight[key] = exports.strings.fromJSON(value);
            });
        }
        if (object.data !== undefined && object.data !== null) {
            message.data = String(object.data);
        }
        else {
            message.data = "";
        }
        if (object.score !== undefined && object.score !== null) {
            message.score = Number(object.score);
        }
        else {
            message.score = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        obj.Highlight = {};
        if (message.Highlight) {
            Object.entries(message.Highlight).forEach(([k, v]) => {
                obj.Highlight[k] = exports.strings.toJSON(v);
            });
        }
        message.data !== undefined && (obj.data = message.data);
        message.score !== undefined && (obj.score = message.score);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDocItem);
        message.Highlight = {};
        if (object.Highlight !== undefined && object.Highlight !== null) {
            Object.entries(object.Highlight).forEach(([key, value]) => {
                if (value !== undefined) {
                    message.Highlight[key] = exports.strings.fromPartial(value);
                }
            });
        }
        if (object.data !== undefined && object.data !== null) {
            message.data = object.data;
        }
        else {
            message.data = "";
        }
        if (object.score !== undefined && object.score !== null) {
            message.score = object.score;
        }
        else {
            message.score = 0;
        }
        return message;
    },
};
const baseDocItem_HighlightEntry = { key: "" };
exports.DocItem_HighlightEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.strings.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDocItem_HighlightEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = exports.strings.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDocItem_HighlightEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = String(object.key);
        }
        else {
            message.key = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = exports.strings.fromJSON(object.value);
        }
        else {
            message.value = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value ? exports.strings.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDocItem_HighlightEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = object.key;
        }
        else {
            message.key = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = exports.strings.fromPartial(object.value);
        }
        else {
            message.value = undefined;
        }
        return message;
    },
};
const basestrings = { strings: "" };
exports.strings = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.strings) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, basestrings);
        message.strings = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.strings.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, basestrings);
        message.strings = [];
        if (object.strings !== undefined && object.strings !== null) {
            for (const e of object.strings) {
                message.strings.push(String(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.strings) {
            obj.strings = message.strings.map((e) => e);
        }
        else {
            obj.strings = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, basestrings);
        message.strings = [];
        if (object.strings !== undefined && object.strings !== null) {
            for (const e of object.strings) {
                message.strings.push(e);
            }
        }
        return message;
    },
};
const baseSearchFilters = {};
exports.SearchFilters = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.searchFilter) {
            exports.SearchFilter.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSearchFilters);
        message.searchFilter = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.searchFilter.push(exports.SearchFilter.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSearchFilters);
        message.searchFilter = [];
        if (object.searchFilter !== undefined && object.searchFilter !== null) {
            for (const e of object.searchFilter) {
                message.searchFilter.push(exports.SearchFilter.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.searchFilter) {
            obj.searchFilter = message.searchFilter.map((e) => (e ? exports.SearchFilter.toJSON(e) : undefined));
        }
        else {
            obj.searchFilter = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSearchFilters);
        message.searchFilter = [];
        if (object.searchFilter !== undefined && object.searchFilter !== null) {
            for (const e of object.searchFilter) {
                message.searchFilter.push(exports.SearchFilter.fromPartial(e));
            }
        }
        return message;
    },
};
const baseSearchFilter = { type: "", field: "", value: "", from: 0, to: 0, docCount: long_1.default.ZERO };
exports.SearchFilter = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.field !== "") {
            writer.uint32(18).string(message.field);
        }
        if (message.value !== "") {
            writer.uint32(26).string(message.value);
        }
        if (message.from !== 0) {
            writer.uint32(37).float(message.from);
        }
        if (message.to !== 0) {
            writer.uint32(45).float(message.to);
        }
        if (!message.docCount.isZero()) {
            writer.uint32(48).int64(message.docCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSearchFilter);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.field = reader.string();
                    break;
                case 3:
                    message.value = reader.string();
                    break;
                case 4:
                    message.from = reader.float();
                    break;
                case 5:
                    message.to = reader.float();
                    break;
                case 6:
                    message.docCount = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSearchFilter);
        if (object.type !== undefined && object.type !== null) {
            message.type = String(object.type);
        }
        else {
            message.type = "";
        }
        if (object.field !== undefined && object.field !== null) {
            message.field = String(object.field);
        }
        else {
            message.field = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = String(object.value);
        }
        else {
            message.value = "";
        }
        if (object.from !== undefined && object.from !== null) {
            message.from = Number(object.from);
        }
        else {
            message.from = 0;
        }
        if (object.to !== undefined && object.to !== null) {
            message.to = Number(object.to);
        }
        else {
            message.to = 0;
        }
        if (object.docCount !== undefined && object.docCount !== null) {
            message.docCount = long_1.default.fromString(object.docCount);
        }
        else {
            message.docCount = long_1.default.ZERO;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.field !== undefined && (obj.field = message.field);
        message.value !== undefined && (obj.value = message.value);
        message.from !== undefined && (obj.from = message.from);
        message.to !== undefined && (obj.to = message.to);
        message.docCount !== undefined && (obj.docCount = (message.docCount || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSearchFilter);
        if (object.type !== undefined && object.type !== null) {
            message.type = object.type;
        }
        else {
            message.type = "";
        }
        if (object.field !== undefined && object.field !== null) {
            message.field = object.field;
        }
        else {
            message.field = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = "";
        }
        if (object.from !== undefined && object.from !== null) {
            message.from = object.from;
        }
        else {
            message.from = 0;
        }
        if (object.to !== undefined && object.to !== null) {
            message.to = object.to;
        }
        else {
            message.to = 0;
        }
        if (object.docCount !== undefined && object.docCount !== null) {
            message.docCount = object.docCount;
        }
        else {
            message.docCount = long_1.default.ZERO;
        }
        return message;
    },
};
const baseFieldValueFactor = { field: "", factor: 0, missing: 0, weight: 0, modifier: "" };
exports.FieldValueFactor = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.field !== "") {
            writer.uint32(10).string(message.field);
        }
        if (message.factor !== 0) {
            writer.uint32(17).double(message.factor);
        }
        if (message.missing !== 0) {
            writer.uint32(25).double(message.missing);
        }
        if (message.weight !== 0) {
            writer.uint32(33).double(message.weight);
        }
        if (message.modifier !== "") {
            writer.uint32(42).string(message.modifier);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseFieldValueFactor);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.field = reader.string();
                    break;
                case 2:
                    message.factor = reader.double();
                    break;
                case 3:
                    message.missing = reader.double();
                    break;
                case 4:
                    message.weight = reader.double();
                    break;
                case 5:
                    message.modifier = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseFieldValueFactor);
        if (object.field !== undefined && object.field !== null) {
            message.field = String(object.field);
        }
        else {
            message.field = "";
        }
        if (object.factor !== undefined && object.factor !== null) {
            message.factor = Number(object.factor);
        }
        else {
            message.factor = 0;
        }
        if (object.missing !== undefined && object.missing !== null) {
            message.missing = Number(object.missing);
        }
        else {
            message.missing = 0;
        }
        if (object.weight !== undefined && object.weight !== null) {
            message.weight = Number(object.weight);
        }
        else {
            message.weight = 0;
        }
        if (object.modifier !== undefined && object.modifier !== null) {
            message.modifier = String(object.modifier);
        }
        else {
            message.modifier = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.field !== undefined && (obj.field = message.field);
        message.factor !== undefined && (obj.factor = message.factor);
        message.missing !== undefined && (obj.missing = message.missing);
        message.weight !== undefined && (obj.weight = message.weight);
        message.modifier !== undefined && (obj.modifier = message.modifier);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseFieldValueFactor);
        if (object.field !== undefined && object.field !== null) {
            message.field = object.field;
        }
        else {
            message.field = "";
        }
        if (object.factor !== undefined && object.factor !== null) {
            message.factor = object.factor;
        }
        else {
            message.factor = 0;
        }
        if (object.missing !== undefined && object.missing !== null) {
            message.missing = object.missing;
        }
        else {
            message.missing = 0;
        }
        if (object.weight !== undefined && object.weight !== null) {
            message.weight = object.weight;
        }
        else {
            message.weight = 0;
        }
        if (object.modifier !== undefined && object.modifier !== null) {
            message.modifier = object.modifier;
        }
        else {
            message.modifier = "";
        }
        return message;
    },
};
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromJSON(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromPartial(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
};
const baseSQLQueryRequest = { sql: "" };
exports.SQLQueryRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sql !== "") {
            writer.uint32(10).string(message.sql);
        }
        for (const v of message.arguments) {
            sql_engine_1.Argument.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLQueryRequest);
        message.arguments = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sql = reader.string();
                    break;
                case 2:
                    message.arguments.push(sql_engine_1.Argument.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSQLQueryRequest);
        message.arguments = [];
        if (object.sql !== undefined && object.sql !== null) {
            message.sql = String(object.sql);
        }
        else {
            message.sql = "";
        }
        if (object.arguments !== undefined && object.arguments !== null) {
            for (const e of object.arguments) {
                message.arguments.push(sql_engine_1.Argument.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.sql !== undefined && (obj.sql = message.sql);
        if (message.arguments) {
            obj.arguments = message.arguments.map((e) => (e ? sql_engine_1.Argument.toJSON(e) : undefined));
        }
        else {
            obj.arguments = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSQLQueryRequest);
        message.arguments = [];
        if (object.sql !== undefined && object.sql !== null) {
            message.sql = object.sql;
        }
        else {
            message.sql = "";
        }
        if (object.arguments !== undefined && object.arguments !== null) {
            for (const e of object.arguments) {
                message.arguments.push(sql_engine_1.Argument.fromPartial(e));
            }
        }
        return message;
    },
};
const baseSQLQueryResponse = { tookTimes: 0 };
exports.SQLQueryResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.results) {
            sql_engine_1.ResultSet.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.tookTimes !== 0) {
            writer.uint32(21).float(message.tookTimes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLQueryResponse);
        message.results = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.results.push(sql_engine_1.ResultSet.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.tookTimes = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSQLQueryResponse);
        message.results = [];
        if (object.results !== undefined && object.results !== null) {
            for (const e of object.results) {
                message.results.push(sql_engine_1.ResultSet.fromJSON(e));
            }
        }
        if (object.tookTimes !== undefined && object.tookTimes !== null) {
            message.tookTimes = Number(object.tookTimes);
        }
        else {
            message.tookTimes = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.results) {
            obj.results = message.results.map((e) => (e ? sql_engine_1.ResultSet.toJSON(e) : undefined));
        }
        else {
            obj.results = [];
        }
        message.tookTimes !== undefined && (obj.tookTimes = message.tookTimes);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSQLQueryResponse);
        message.results = [];
        if (object.results !== undefined && object.results !== null) {
            for (const e of object.results) {
                message.results.push(sql_engine_1.ResultSet.fromPartial(e));
            }
        }
        if (object.tookTimes !== undefined && object.tookTimes !== null) {
            message.tookTimes = object.tookTimes;
        }
        else {
            message.tookTimes = 0;
        }
        return message;
    },
};
const baseSimpleSQLQueryResponse = {};
exports.SimpleSQLQueryResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.result) {
            exports.SimpleSQLQueryResponse_ResultSet.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSimpleSQLQueryResponse);
        message.result = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result.push(exports.SimpleSQLQueryResponse_ResultSet.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSimpleSQLQueryResponse);
        message.result = [];
        if (object.result !== undefined && object.result !== null) {
            for (const e of object.result) {
                message.result.push(exports.SimpleSQLQueryResponse_ResultSet.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.result) {
            obj.result = message.result.map((e) => (e ? exports.SimpleSQLQueryResponse_ResultSet.toJSON(e) : undefined));
        }
        else {
            obj.result = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSimpleSQLQueryResponse);
        message.result = [];
        if (object.result !== undefined && object.result !== null) {
            for (const e of object.result) {
                message.result.push(exports.SimpleSQLQueryResponse_ResultSet.fromPartial(e));
            }
        }
        return message;
    },
};
const baseSimpleSQLQueryResponse_ResultSet = {};
exports.SimpleSQLQueryResponse_ResultSet = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.row).forEach(([key, value]) => {
            exports.SimpleSQLQueryResponse_ResultSet_RowEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSimpleSQLQueryResponse_ResultSet);
        message.row = {};
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    const entry1 = exports.SimpleSQLQueryResponse_ResultSet_RowEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.row[entry1.key] = entry1.value;
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSimpleSQLQueryResponse_ResultSet);
        message.row = {};
        if (object.row !== undefined && object.row !== null) {
            Object.entries(object.row).forEach(([key, value]) => {
                message.row[key] = exports.SimpleSQLQueryResponse_RowValue.fromJSON(value);
            });
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        obj.row = {};
        if (message.row) {
            Object.entries(message.row).forEach(([k, v]) => {
                obj.row[k] = exports.SimpleSQLQueryResponse_RowValue.toJSON(v);
            });
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSimpleSQLQueryResponse_ResultSet);
        message.row = {};
        if (object.row !== undefined && object.row !== null) {
            Object.entries(object.row).forEach(([key, value]) => {
                if (value !== undefined) {
                    message.row[key] = exports.SimpleSQLQueryResponse_RowValue.fromPartial(value);
                }
            });
        }
        return message;
    },
};
const baseSimpleSQLQueryResponse_ResultSet_RowEntry = { key: "" };
exports.SimpleSQLQueryResponse_ResultSet_RowEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.SimpleSQLQueryResponse_RowValue.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSimpleSQLQueryResponse_ResultSet_RowEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = exports.SimpleSQLQueryResponse_RowValue.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSimpleSQLQueryResponse_ResultSet_RowEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = String(object.key);
        }
        else {
            message.key = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = exports.SimpleSQLQueryResponse_RowValue.fromJSON(object.value);
        }
        else {
            message.value = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined &&
            (obj.value = message.value ? exports.SimpleSQLQueryResponse_RowValue.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSimpleSQLQueryResponse_ResultSet_RowEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = object.key;
        }
        else {
            message.key = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = exports.SimpleSQLQueryResponse_RowValue.fromPartial(object.value);
        }
        else {
            message.value = undefined;
        }
        return message;
    },
};
const baseSimpleSQLQueryResponse_RowValue = { value: "", columnValueType: 0 };
exports.SimpleSQLQueryResponse_RowValue = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.value !== "") {
            writer.uint32(10).string(message.value);
        }
        if (message.columnValueType !== 0) {
            writer.uint32(16).int32(message.columnValueType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSimpleSQLQueryResponse_RowValue);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.string();
                    break;
                case 2:
                    message.columnValueType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSimpleSQLQueryResponse_RowValue);
        if (object.value !== undefined && object.value !== null) {
            message.value = String(object.value);
        }
        else {
            message.value = "";
        }
        if (object.columnValueType !== undefined && object.columnValueType !== null) {
            message.columnValueType = sql_engine_1.columnValueTypeFromJSON(object.columnValueType);
        }
        else {
            message.columnValueType = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = message.value);
        message.columnValueType !== undefined &&
            (obj.columnValueType = sql_engine_1.columnValueTypeToJSON(message.columnValueType));
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSimpleSQLQueryResponse_RowValue);
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = "";
        }
        if (object.columnValueType !== undefined && object.columnValueType !== null) {
            message.columnValueType = object.columnValueType;
        }
        else {
            message.columnValueType = 0;
        }
        return message;
    },
};
const baseSQLListTablesRequest = { keyword: "", uid: "", page: 0, pageSize: 0, database: "" };
exports.SQLListTablesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.keyword !== "") {
            writer.uint32(10).string(message.keyword);
        }
        if (message.uid !== "") {
            writer.uint32(18).string(message.uid);
        }
        if (message.page !== 0) {
            writer.uint32(24).int32(message.page);
        }
        if (message.pageSize !== 0) {
            writer.uint32(32).int32(message.pageSize);
        }
        if (message.database !== "") {
            writer.uint32(42).string(message.database);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLListTablesRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.keyword = reader.string();
                    break;
                case 2:
                    message.uid = reader.string();
                    break;
                case 3:
                    message.page = reader.int32();
                    break;
                case 4:
                    message.pageSize = reader.int32();
                    break;
                case 5:
                    message.database = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSQLListTablesRequest);
        if (object.keyword !== undefined && object.keyword !== null) {
            message.keyword = String(object.keyword);
        }
        else {
            message.keyword = "";
        }
        if (object.uid !== undefined && object.uid !== null) {
            message.uid = String(object.uid);
        }
        else {
            message.uid = "";
        }
        if (object.page !== undefined && object.page !== null) {
            message.page = Number(object.page);
        }
        else {
            message.page = 0;
        }
        if (object.pageSize !== undefined && object.pageSize !== null) {
            message.pageSize = Number(object.pageSize);
        }
        else {
            message.pageSize = 0;
        }
        if (object.database !== undefined && object.database !== null) {
            message.database = String(object.database);
        }
        else {
            message.database = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.keyword !== undefined && (obj.keyword = message.keyword);
        message.uid !== undefined && (obj.uid = message.uid);
        message.page !== undefined && (obj.page = message.page);
        message.pageSize !== undefined && (obj.pageSize = message.pageSize);
        message.database !== undefined && (obj.database = message.database);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSQLListTablesRequest);
        if (object.keyword !== undefined && object.keyword !== null) {
            message.keyword = object.keyword;
        }
        else {
            message.keyword = "";
        }
        if (object.uid !== undefined && object.uid !== null) {
            message.uid = object.uid;
        }
        else {
            message.uid = "";
        }
        if (object.page !== undefined && object.page !== null) {
            message.page = object.page;
        }
        else {
            message.page = 0;
        }
        if (object.pageSize !== undefined && object.pageSize !== null) {
            message.pageSize = object.pageSize;
        }
        else {
            message.pageSize = 0;
        }
        if (object.database !== undefined && object.database !== null) {
            message.database = object.database;
        }
        else {
            message.database = "";
        }
        return message;
    },
};
const baseSQLListTablesResponse = {};
exports.SQLListTablesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.tables) {
            sql_engine_1.TableInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLListTablesResponse);
        message.tables = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tables.push(sql_engine_1.TableInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSQLListTablesResponse);
        message.tables = [];
        if (object.tables !== undefined && object.tables !== null) {
            for (const e of object.tables) {
                message.tables.push(sql_engine_1.TableInfo.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tables) {
            obj.tables = message.tables.map((e) => (e ? sql_engine_1.TableInfo.toJSON(e) : undefined));
        }
        else {
            obj.tables = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSQLListTablesResponse);
        message.tables = [];
        if (object.tables !== undefined && object.tables !== null) {
            for (const e of object.tables) {
                message.tables.push(sql_engine_1.TableInfo.fromPartial(e));
            }
        }
        return message;
    },
};
const baseSQLListDatabasesRequest = {};
exports.SQLListDatabasesRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLListDatabasesRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseSQLListDatabasesRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseSQLListDatabasesRequest);
        return message;
    },
};
const baseSQLListDatabasesResponse = {};
exports.SQLListDatabasesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.databases) {
            sql_engine_1.DatabaseInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLListDatabasesResponse);
        message.databases = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.databases.push(sql_engine_1.DatabaseInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSQLListDatabasesResponse);
        message.databases = [];
        if (object.databases !== undefined && object.databases !== null) {
            for (const e of object.databases) {
                message.databases.push(sql_engine_1.DatabaseInfo.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.databases) {
            obj.databases = message.databases.map((e) => (e ? sql_engine_1.DatabaseInfo.toJSON(e) : undefined));
        }
        else {
            obj.databases = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSQLListDatabasesResponse);
        message.databases = [];
        if (object.databases !== undefined && object.databases !== null) {
            for (const e of object.databases) {
                message.databases.push(sql_engine_1.DatabaseInfo.fromPartial(e));
            }
        }
        return message;
    },
};
const baseShowCreateTableRequest = { databaseName: "", tableName: "" };
exports.ShowCreateTableRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.databaseName !== "") {
            writer.uint32(10).string(message.databaseName);
        }
        if (message.tableName !== "") {
            writer.uint32(18).string(message.tableName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseShowCreateTableRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.databaseName = reader.string();
                    break;
                case 2:
                    message.tableName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseShowCreateTableRequest);
        if (object.databaseName !== undefined && object.databaseName !== null) {
            message.databaseName = String(object.databaseName);
        }
        else {
            message.databaseName = "";
        }
        if (object.tableName !== undefined && object.tableName !== null) {
            message.tableName = String(object.tableName);
        }
        else {
            message.tableName = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.databaseName !== undefined && (obj.databaseName = message.databaseName);
        message.tableName !== undefined && (obj.tableName = message.tableName);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseShowCreateTableRequest);
        if (object.databaseName !== undefined && object.databaseName !== null) {
            message.databaseName = object.databaseName;
        }
        else {
            message.databaseName = "";
        }
        if (object.tableName !== undefined && object.tableName !== null) {
            message.tableName = object.tableName;
        }
        else {
            message.tableName = "";
        }
        return message;
    },
};
const baseShowCreateTableResponse = { schema: "" };
exports.ShowCreateTableResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.schema !== "") {
            writer.uint32(10).string(message.schema);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseShowCreateTableResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.schema = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseShowCreateTableResponse);
        if (object.schema !== undefined && object.schema !== null) {
            message.schema = String(object.schema);
        }
        else {
            message.schema = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.schema !== undefined && (obj.schema = message.schema);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseShowCreateTableResponse);
        if (object.schema !== undefined && object.schema !== null) {
            message.schema = object.schema;
        }
        else {
            message.schema = "";
        }
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.ListSchema = this.ListSchema.bind(this);
        this.GetSchema = this.GetSchema.bind(this);
        this.GetDoc = this.GetDoc.bind(this);
        this.SearchDoc = this.SearchDoc.bind(this);
        this.Params = this.Params.bind(this);
        this.SQLQuery = this.SQLQuery.bind(this);
        this.SimpleSQLQuery = this.SimpleSQLQuery.bind(this);
        this.SQLListTables = this.SQLListTables.bind(this);
        this.SQLListDatabases = this.SQLListDatabases.bind(this);
        this.ShowCreateTable = this.ShowCreateTable.bind(this);
    }
    ListSchema(request, metadata) {
        return this.rpc.unary(exports.QueryListSchemaDesc, exports.ListSchemaRequest.fromPartial(request), metadata);
    }
    GetSchema(request, metadata) {
        return this.rpc.unary(exports.QueryGetSchemaDesc, exports.GetSchemaRequest.fromPartial(request), metadata);
    }
    GetDoc(request, metadata) {
        return this.rpc.unary(exports.QueryGetDocDesc, exports.GetDocRequest.fromPartial(request), metadata);
    }
    SearchDoc(request, metadata) {
        return this.rpc.unary(exports.QuerySearchDocDesc, exports.SearchDocRequest.fromPartial(request), metadata);
    }
    Params(request, metadata) {
        return this.rpc.unary(exports.QueryParamsDesc, exports.QueryParamsRequest.fromPartial(request), metadata);
    }
    SQLQuery(request, metadata) {
        return this.rpc.unary(exports.QuerySQLQueryDesc, exports.SQLQueryRequest.fromPartial(request), metadata);
    }
    SimpleSQLQuery(request, metadata) {
        return this.rpc.unary(exports.QuerySimpleSQLQueryDesc, exports.SQLQueryRequest.fromPartial(request), metadata);
    }
    SQLListTables(request, metadata) {
        return this.rpc.unary(exports.QuerySQLListTablesDesc, exports.SQLListTablesRequest.fromPartial(request), metadata);
    }
    SQLListDatabases(request, metadata) {
        return this.rpc.unary(exports.QuerySQLListDatabasesDesc, exports.SQLListDatabasesRequest.fromPartial(request), metadata);
    }
    ShowCreateTable(request, metadata) {
        return this.rpc.unary(exports.QueryShowCreateTableDesc, exports.ShowCreateTableRequest.fromPartial(request), metadata);
    }
}
exports.QueryClientImpl = QueryClientImpl;
exports.QueryDesc = {
    serviceName: "blockved.glitterchain.index.Query",
};
exports.QueryListSchemaDesc = {
    methodName: "ListSchema",
    service: exports.QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.ListSchemaRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.ListSchemaResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.QueryGetSchemaDesc = {
    methodName: "GetSchema",
    service: exports.QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.GetSchemaRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.GetSchemaResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.QueryGetDocDesc = {
    methodName: "GetDoc",
    service: exports.QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.GetDocRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.GetDocResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.QuerySearchDocDesc = {
    methodName: "SearchDoc",
    service: exports.QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.SearchDocRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.SearchDocResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.QueryParamsDesc = {
    methodName: "Params",
    service: exports.QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.QueryParamsRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.QueryParamsResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.QuerySQLQueryDesc = {
    methodName: "SQLQuery",
    service: exports.QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.SQLQueryRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.SQLQueryResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.QuerySimpleSQLQueryDesc = {
    methodName: "SimpleSQLQuery",
    service: exports.QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.SQLQueryRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.SimpleSQLQueryResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.QuerySQLListTablesDesc = {
    methodName: "SQLListTables",
    service: exports.QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.SQLListTablesRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.SQLListTablesResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.QuerySQLListDatabasesDesc = {
    methodName: "SQLListDatabases",
    service: exports.QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.SQLListDatabasesRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.SQLListDatabasesResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.QueryShowCreateTableDesc = {
    methodName: "ShowCreateTable",
    service: exports.QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.ShowCreateTableRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.ShowCreateTableResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
class GrpcWebImpl {
    constructor(host, options) {
        this.host = host;
        this.options = options;
    }
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata
            ? new browser_headers_1.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap))
            : metadata || this.options.metadata;
        return new Promise((resolve, reject) => {
            grpc_web_1.grpc.unary(methodDesc, {
                request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function (response) {
                    if (response.status === grpc_web_1.grpc.Code.OK) {
                        resolve(response.message);
                    }
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                },
            });
        });
    }
}
exports.GrpcWebImpl = GrpcWebImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=query.js.map